import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  getPipelineUrlParams,
  hasPipelineUrlContext,
  resolvePipelineUrlContext,
} from "../helpers/PipelineFilterHelper";

export function usePipelineUrlFilters({
  user_token,
  searchParams,
  navigate,
  routePath,
  clientColumn,
  requirementColumn,
  setFilters,
  clients,
  onPrefillApplied,
}) {
  const location = useLocation();
  const statePrefill = location.state?.pipelinePrefill;
  const urlHasContext = hasPipelineUrlContext(searchParams);

  const [chips, setChips] = useState(statePrefill?.chips || []);
  const [urlSynced, setUrlSynced] = useState(Boolean(statePrefill) || !urlHasContext);

  useEffect(() => {
    if (statePrefill) {
      setFilters((prev) => ({
        ...prev,
        ...(statePrefill.clientOption ? { [clientColumn]: statePrefill.clientOption } : {}),
        ...(statePrefill.requirementOption
          ? { [requirementColumn]: statePrefill.requirementOption }
          : {}),
      }));
      setChips(statePrefill.chips || []);
      setUrlSynced(true);
      onPrefillApplied?.(statePrefill);
      return undefined;
    }

    const { clientId, requirementId } = getPipelineUrlParams(searchParams);
    if (!clientId && !requirementId) {
      setUrlSynced(true);
      return undefined;
    }

    if (clientId && clients?.length) {
      const existingClient = clients.find(
        (c) => String(c.value) === String(clientId)
      );
      if (existingClient) {
        setFilters((prev) => ({
          ...prev,
          [clientColumn]: existingClient,
        }));
      }
    }

    let cancelled = false;

    (async () => {
      const resolved = await resolvePipelineUrlContext(
        user_token,
        searchParams,
        clients
      );

      if (cancelled) return;

      if (resolved.clientOption || resolved.requirementOption) {
        setFilters((prev) => ({
          ...prev,
          ...(resolved.clientOption ? { [clientColumn]: resolved.clientOption } : {}),
          ...(resolved.requirementOption
            ? { [requirementColumn]: resolved.requirementOption }
            : {}),
        }));
        onPrefillApplied?.({
          clientOption: resolved.clientOption,
          requirementOption: resolved.requirementOption,
        });
      }

      setChips(resolved.chips);
      setUrlSynced(true);
    })();

    return () => {
      cancelled = true;
    };
  }, [
    user_token,
    searchParams,
    clients,
    clientColumn,
    requirementColumn,
    setFilters,
    statePrefill,
    onPrefillApplied,
  ]);

  const clearUrlContext = () => {
    navigate(routePath);
    setChips([]);
    setUrlSynced(true);
  };

  return { chips, clearUrlContext, urlSynced };
}
